/**
 * ASA Rugs – app-free favourites ("wishlist").
 *
 * Storage (visitor's browser only, no account needed):
 *   asa-rugs-wishlist       → ["123", "456", …]  product IDs in the order they were saved
 *   asa-rugs-wishlist-meta  → { "123": { h: "handle", a: 1727790000000 }, … }
 *
 * Public API: window.AsaWishlist  (get, has, add, remove, toggle, count, meta, set)
 * Events on document: "asa:wishlist-change"  detail: { ids, id, active, source }
 *
 * Works with every heart button rendered anywhere ([data-wishlist-toggle]), including cards
 * added later by filtering, infinite scroll, quick add, search or the favourites page.
 */
(function () {
  if (window.AsaWishlist) return;

  var KEY = 'asa-rugs-wishlist';
  var META_KEY = 'asa-rugs-wishlist-meta';
  var MAX_ITEMS = 200;

  function read(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* storage unavailable (private mode, quota) – the session simply won't remember */
    }
  }

  function getIds() {
    var ids = read(KEY, []);
    return Array.isArray(ids) ? ids.map(String) : [];
  }

  function getMeta() {
    var meta = read(META_KEY, {});
    return meta && typeof meta === 'object' ? meta : {};
  }

  function emit(detail) {
    document.dispatchEvent(new CustomEvent('asa:wishlist-change', { detail: detail }));
  }

  function setIds(ids, meta, detail) {
    var unique = [];
    ids.forEach(function (id) {
      id = String(id);
      if (id && unique.indexOf(id) === -1) unique.push(id);
    });
    if (unique.length > MAX_ITEMS) unique = unique.slice(unique.length - MAX_ITEMS);

    var cleanMeta = {};
    unique.forEach(function (id) {
      if (meta[id]) cleanMeta[id] = meta[id];
    });

    write(KEY, unique);
    write(META_KEY, cleanMeta);
    refresh(document);
    emit(Object.assign({ ids: unique.slice() }, detail || {}));
    return unique;
  }

  function has(id) {
    return getIds().indexOf(String(id)) > -1;
  }

  function add(id, handle, source) {
    id = String(id);
    var ids = getIds();
    var meta = getMeta();
    if (ids.indexOf(id) === -1) ids.push(id);
    meta[id] = { h: handle || (meta[id] && meta[id].h) || '', a: (meta[id] && meta[id].a) || Date.now() };
    setIds(ids, meta, { id: id, active: true, source: source || 'api' });
    return true;
  }

  function remove(id, source) {
    id = String(id);
    var ids = getIds().filter(function (x) {
      return x !== id;
    });
    setIds(ids, getMeta(), { id: id, active: false, source: source || 'api' });
    return false;
  }

  function toggle(id, handle, source) {
    return has(id) ? remove(id, source) : add(id, handle, source);
  }

  /* ---------- UI sync ---------- */

  function syncButton(button, ids) {
    var id = button.getAttribute('data-product-id');
    var active = ids.indexOf(String(id)) > -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from favourites' : 'Save to favourites');
  }

  function syncCounts(ids) {
    var count = ids.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-wishlist-link]').forEach(function (el) {
      el.classList.toggle('has-items', count > 0);
      el.setAttribute('aria-label', count ? 'Favourites (' + count + ')' : 'Favourites');
    });
  }

  function refresh(root) {
    var ids = getIds();
    var scope = root || document;
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
        syncButton(b, ids);
      });
    }
    syncCounts(ids);
  }

  /* Older entries only stored the ID: learn the handle from any heart rendered on the page. */
  function backfillHandles(root) {
    var meta = getMeta();
    var ids = getIds();
    var changed = false;
    (root || document).querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach(function (b) {
      var id = b.getAttribute('data-product-id');
      var handle = b.getAttribute('data-product-handle');
      if (ids.indexOf(id) > -1 && handle && (!meta[id] || !meta[id].h)) {
        meta[id] = { h: handle, a: (meta[id] && meta[id].a) || Date.now() };
        changed = true;
      }
    });
    if (changed) write(META_KEY, meta);
  }

  /* ---------- Feedback: header heart pulse + small toast ---------- */

  var toastTimer;
  function pulseHeader() {
    document.querySelectorAll('[data-wishlist-link]').forEach(function (link) {
      link.classList.remove('is-pulsing');
      void link.offsetWidth;
      link.classList.add('is-pulsing');
    });
  }

  function showToast(text, actionLabel, onAction) {
    var t = document.querySelector('.asa-wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'asa-wl-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML =
        '<svg class="asa-wl-toast__icon" viewBox="0 0 20 20" aria-hidden="true"><path d="M10 17.1s-6.35-3.98-8.39-7.68C.36 6.7 1.5 3.55 4.47 2.75c1.86-.5 3.77.26 4.87 1.86l.66.96.66-.96c1.1-1.6 3.01-2.36 4.87-1.86 2.97.8 4.11 3.95 2.86 6.67C16.35 13.12 10 17.1 10 17.1Z"/></svg>' +
        '<span class="asa-wl-toast__text"></span><a class="asa-wl-toast__btn"></a>';
      document.body.appendChild(t);
      t.addEventListener('mouseenter', function () {
        clearTimeout(toastTimer);
      });
      t.addEventListener('mouseleave', function () {
        toastTimer = setTimeout(hide, 1600);
      });
    }
    function hide() {
      t.classList.remove('is-visible');
    }
    t.querySelector('.asa-wl-toast__text').textContent = text;
    var btn = t.querySelector('.asa-wl-toast__btn');
    btn.textContent = actionLabel || '';
    btn.hidden = !actionLabel;
    btn.onclick = null;
    btn.removeAttribute('href');
    if (typeof onAction === 'string') {
      btn.setAttribute('href', onAction);
    } else if (typeof onAction === 'function') {
      btn.setAttribute('href', '#');
      btn.onclick = function (e) {
        e.preventDefault();
        hide();
        onAction();
      };
    }
    requestAnimationFrame(function () {
      t.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hide, 3200);
  }

  function favouritesUrl() {
    var link = document.querySelector('[data-wishlist-link]');
    return (link && link.getAttribute('href')) || '/pages/favourites';
  }

  /* ---------- Clicks on any heart ---------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    // The whole product card is a link: a tap on the heart must only toggle the favourite.
    event.preventDefault();
    event.stopPropagation();

    var id = button.getAttribute('data-product-id');
    if (!id) return;

    var active = toggle(id, button.getAttribute('data-product-handle'), 'button');

    button.classList.remove('is-animating');
    void button.offsetWidth;
    button.classList.add('is-animating');

    if (active) {
      pulseHeader();
      if (!document.querySelector('[data-asa-wishlist-page]')) {
        showToast('Saved to your favourites', 'View', favouritesUrl());
      }
    }
  });

  /* ---------- Keep everything in sync ---------- */

  function onReady() {
    backfillHandles(document);
    refresh(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  // Another tab changed the list
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) {
      refresh(document);
      emit({ ids: getIds(), source: 'storage' });
    }
  });

  // Cards re-rendered by filtering / infinite scroll / quick add / search:
  // only look at what was actually added instead of re-scanning the whole page.
  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var ids = getIds();
    var nodes = pending;
    pending = [];
    nodes.forEach(function (node) {
      if (!node.isConnected) return;
      if (node.matches('[data-wishlist-toggle]')) syncButton(node, ids);
      node.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
        syncButton(b, ids);
      });
      if (node.matches('[data-wishlist-count]') || node.querySelector('[data-wishlist-count]')) syncCounts(ids);
    });
  }

  function observe() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) pending.push(added[j]);
        }
      }
      if (pending.length && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe);

  window.AsaWishlist = {
    get: getIds,
    meta: getMeta,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: function () {
      return getIds().length;
    },
    set: function (ids, meta) {
      return setIds(ids, meta || getMeta(), { source: 'api' });
    },
    refresh: refresh,
    toast: showToast,
  };
})();
